import './NoteEditArea.scss';
import React from 'react';
import moment from 'moment';
import NoteInputArea from './NoteInputArea';
import { Note } from '../../interfaces/Notes/note';

interface EditNoteProps {
    note: Note;
    index: number;
    onCancel: () => void;
    onEditNote: (note: string, noteId: number) => void;
}

const NoteEditArea = ({ note, index, onCancel, onEditNote }: EditNoteProps): React.ReactElement => {
    const datePart = moment(note.createdAtUtc.toString()).format('MMM DD, YYYY');
    const timePart = moment(note.createdAtUtc.toString()).format('h:mm A z');

    const onCancelNote = (): void => {
        onCancel();
    };

    const onSaveNote = (note: string, noteId: number): void => {
        onEditNote(note, noteId);
        onCancel();
    };

    return (
        <div
            className={`NoteEditArea-Container ${
                index % 2 === 0 ? 'NoteEditArea-OddBackground' : 'NoteEditArea-EvenBackground'
            }`}
        >
            <div className="NoteEditArea-DetailsContainer">
                <span className="NoteEditArea-UserName">{note.name}</span>
            </div>
            <div className="NoteEditArea-DetailsContainer">
                <span className="NoteEditArea-DateTime">
                    {datePart}
                    <span className="NoteEditArea-Divider">|</span>
                    {timePart}
                </span>
            </div>
            <NoteInputArea
                onSaveNote={noteText => {
                    onSaveNote(noteText, note.noteId);
                }}
                onEditNote={onEditNote}
                noteText={note.notes}
                isEditMode
                onCancel={onCancelNote}
                noteId={note.noteId}
            />
        </div>
    );
};

export default NoteEditArea;

